/** App shell header — `Header` (`data-app-chrome="top"`). */
export const CHROME_TOP = '[data-app-chrome="top"]';
/** App shell bottom bar — `BottomNav` (`data-app-chrome="bottom"`). */
export const CHROME_BOTTOM = '[data-app-chrome="bottom"]';

/** Vertical span in layout-viewport coordinates (what getBoundingClientRect uses). */
export interface VerticalBand {
  top: number;
  bottom: number;
}

/** Visible area: the visual viewport (above the keyboard), else the window. */
export const getVisibleArea = (): VerticalBand => {
  const vv = window.visualViewport;
  const top = vv ? vv.offsetTop : 0;
  return { top, bottom: top + (vv ? vv.height : window.innerHeight) };
};

const visibleChromeRect = (selector: string): DOMRect | null => {
  const rect = document.querySelector(selector)?.getBoundingClientRect();
  return rect && rect.height > 0 ? rect : null;
};

/**
 * `band` clipped by the app chrome on screen: below the visible Header, above
 * the visible BottomNav (whichever overlaps it). Mutates and returns `band`.
 */
export const clipToAppChrome = (band: VerticalBand): VerticalBand => {
  const header = visibleChromeRect(CHROME_TOP);
  if (header && header.bottom > band.top && header.top < band.bottom) band.top = header.bottom;
  const nav = visibleChromeRect(CHROME_BOTTOM);
  if (nav && nav.top < band.bottom && nav.bottom > band.top) band.bottom = nav.top;
  return band;
};
